import { RetailerKycDetailsType } from './retailer-kyc-details.type';

const INITIAL_STATE = {
    registerRetailerResponse: '',
    personalInfo: '',
    saveDataVal: '',
    roResponse: '',
    roId: '',

    //biometry
    kycBiometricData: '',
    kycBiometricDtaCaptureStatus: '',
    kycdriverStatus: '',

    //paysprint-kyc
    onboardActiveRoId: '',
    onboardResp: '',
    onboardActiveRoIdMap: '',
    merchantOnboardStatus:''


};

const retailerKycReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        //retailer kyc

        case RetailerKycDetailsType.setRegisterRetailerResponse:
            return {
                ...state,
                registerRetailerResponse: action.payload,
            };
        case RetailerKycDetailsType.setPersonalInfo:
            return {
                ...state,
                personalInfo: action.payload,
            };
        case RetailerKycDetailsType.setSaveData:
            return {
                ...state,
                saveDataVal: action.payload,
            };
        case RetailerKycDetailsType.setROResponse:
            return {
                ...state,
                roResponse: action.payload,
            };

        //biometric

        case RetailerKycDetailsType.setBiometricDta:
            return {
                ...state,
                kycBiometricData: action.payload,
            };
        case RetailerKycDetailsType.setBiometricDtaCaptureStatus:
            return {
                ...state,
                kycBiometricDtaCaptureStatus: action.payload,
            };
        case RetailerKycDetailsType.checkingDriverStatus:
            return {
                ...state,
                kycdriverStatus: action.payload,
            };
        case RetailerKycDetailsType.setROId:
            return {
                ...state,
                roId: action.payload,
            };
        case RetailerKycDetailsType.setOnboardActiveRoId:
            return {
                ...state,
                onboardActiveRoId: action.payload,
            };
        case RetailerKycDetailsType.setOnboardResponse:
            return {
                ...state,
                onboardResp: action.payload,
            };
        case RetailerKycDetailsType.setOnboardActiveRoIdMap:
            return {
                ...state,
                onboardActiveRoIdMap: action.payload,
            };
        case RetailerKycDetailsType.setMerchantOnboardStatus:
            return {
                ...state,
                merchantOnboardStatus: action.payload,
            };
        case RetailerKycDetailsType.RESET:
            return INITIAL_STATE;

        default:
            return state;
    }

};

export default retailerKycReducer; 